import * as React from "react";
import { useMemo } from "react";
import usePluginEntities from "hooks/usePluginEntities";
import ExternalValueActionsContext, { DEFAULT_EXTERNAL_ACTIONS } from "./ExternalValueActionsContext";
const usePluginExternalActions = () => {
  const useExternalActions = usePluginEntities("useExternalActions");
  const useExternalAction = useMemo(() => {
    if (useExternalActions && typeof useExternalActions[0] === "function") return useExternalActions[0];
    return () => DEFAULT_EXTERNAL_ACTIONS;
  }, [useExternalActions]);
  const { isLoading, externalValueActions, isError } = useExternalAction();
  return useMemo(() => ({ isLoading, isError, externalValueActions }), [externalValueActions, isError, isLoading]);
};
const ExternalValueActionsProvider = ({ children }) => {
  const contextValue = usePluginExternalActions();
  return /* @__PURE__ */ React.createElement(ExternalValueActionsContext.Provider, { value: contextValue }, children);
};
export default ExternalValueActionsProvider;
